export const MYACCOUNT_EVENTS = {
  MAIN: 'mya',
  LOADED: 'mya.loaded',
};

export const MYACCOUNT_ORDER_DETAILS_EVENTS = {
  MAIN: 'orderDetails',
  LOADED: 'orderDetails.loaded',
  BASIC_LOADED: 'orderDetails.basic_loaded',
};

export const SELL_FLOW_START = {
  HUB: 'hub',
  EVENT: 'event',
  SEARCH: 'search',
  RELIST: 'relist',
  OTHER: 'other',
};

export const SELL_FLOW_EVENTS = {
  MAIN: 'sellflow',
  LISTING_DETAILS_LOADED: 'sellflow.listing_details_loaded',
  LISTING_CREATED: 'sellflow.listing_created',
};

export const MYACCOUNT_LISTINGS_EVENTS = {
  MAIN: 'listings',
  LOADED: 'listings.loaded',
  OPEN_CHANGE_FULFILLMENT_OPTION: 'listings.open_change_fulfillment_option',
  CHANGE_FULFILLMENT: 'listings.change_fulfillment',
  PRICE_CHANGE: 'listings.price_change',
  PAYOUT_CHANGE: 'listings.payout_change',
  TICKET_TYPE_CHANGE: 'listings.ticket_type_change',
  STATUS_CHANGE: 'listings.status_change',
  QUANTITY_CHANGE: 'listings.quantity_change',
  CLICK_BUTTON: 'listings.click_button',
  CLICK_SEARCH: 'listings.click_search',
  DELETE_LISTING: 'listings.delete_listing',
  BULK_UPDATE: 'listings.bulk_update',
  BULK_ACTIONS_DELETE_LISTINGS: 'listings.bulk_actions.delete_listings',
};
